import { useEffect, useState } from 'react';
import { useMediaQuery, styled } from '@mui/material';
import { StyledTablePagination, variables } from '../common';
import { pathOr, always } from 'rambda';
import { flow } from 'fp-ts/function';
import { RequestStatus2d, properties, useLegacyRequestSearch } from '.';
import { RequstStatusFilter2d } from '../admin/RequstStatusFilter2d';

const rowsPerPageOptions = [10, 25, 50, 100, 500];

export const LegacyStatus = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchBy, setSearchBy] = useState('id');
  const [searchP1, setSearchP1] = useState('');
  const [searchP2, setSearchP2] = useState('');

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
    search();
  };

  const { requestStatus, call, search } = useLegacyRequestSearch({
    page,
    pageSize,
    searchBy,
    searchP1: searchP1.trim(),
    searchP2,
  });
  
  const handleChangeRowsPerPage = flow(
    pathOr('10', 'target.value'),
    (a: string) => parseInt(a, 10),
    setPageSize,
    always(0),
    setPage,
    search
  );


  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return (
    <Article>
      {matchesGridBreakpoint && (
        <>
          {requestStatus.total > pageSize && (
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <StyledTablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                count={requestStatus.total}
                rowsPerPage={pageSize}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          )}
        </>
      )}

      <RequstStatusFilter2d
        di={false}
        legacy={true}
        searchBy={searchBy}
        searchP1={searchP1}
        searchP2={searchP2}
        setSearchBy={setSearchBy}
        setSearchP1={setSearchP1}
        setSearchP2={setSearchP2}
        search={() => { setPage(0); search(); }}
      />

      <RequestStatus2d
        properties={properties}
        requests={requestStatus.content}
        getRequstsCallStatus={call}
      />

      {requestStatus.total > pageSize && (
        <StyledTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          count={requestStatus.total}
          rowsPerPage={pageSize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Article>
  );
};

const Article = styled('article')(({ theme }) => ({
  ...variables.childrenMarginTop2x,
}));
